/**
 * True when react-snap left pre-rendered markup in #root. Used to skip framer-motion
 * "initial" states that would mismatch during hydrateRoot.
 */
export const isPrerendered =
  typeof document !== "undefined" &&
  Boolean(document.getElementById("root")?.hasChildNodes());
